export const getPropsByWidget = (initParams) => {
  let widgetProps = {}
  switch (initParams.widget) {
    case 'WLivenow':
    case 'WHighlights':
    case 'WUpcoming':
      widgetProps = {
        maxTabs: initParams.maxtabs
      }
      break
    case 'WBannerEvents':
      widgetProps = {
        eventIds: initParams.eventids,
        isEventCardView: initParams.iseventcardview,
        banners: initParams.banners
      }
      break
    case 'WEvent':
      widgetProps = {
        eventId: initParams.eventid,
        marketType: initParams.markettype
      }
  }
  return widgetProps
}
